import { setToken, getToken } from './storage'

const JWEIXIN_URL = 'https://res.wx.qq.com/open/js/jweixin-1.2.0.js'

let isWxReady = false
let isAgentReady = false

export function isInWechatWork() {
  const ua = navigator.userAgent.toLowerCase()
  return ua.includes('wxwork') || ua.includes('wechatwork')
}

export function loadJWeixin() {
  return new Promise((resolve, reject) => {
    if (window.wx) {
      resolve(window.wx)
      return
    }

    const script = document.createElement('script')
    script.src = JWEIXIN_URL
    script.onload = () => {
      console.log('[企微SDK] jweixin 加载成功')
      resolve(window.wx)
    }
    script.onerror = () => {
      console.error('[企微SDK] jweixin 加载失败')
      reject(new Error('jweixin 加载失败'))
    }
    document.head.appendChild(script)
  })
}

export async function initWxConfig() {
  if (!isInWechatWork()) {
    console.log('[企微SDK] 非企微环境，跳过初始化')
    return false
  }

  try {
    const wx = await loadJWeixin()
    
    const url = window.location.href.split('#')[0]
    console.log('[企微SDK] 获取签名, URL:', url)
    
    const response = await fetch('/api/app/oauth/wechat-work/jsapi-signature', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ url })
    })
    
    const result = await response.json()
    if (result.code !== 200) {
      console.error('[企微SDK] 获取签名失败:', result.msg)
      return false
    }
    
    const { config, agentConfig } = result.data
    
    return new Promise((resolve) => {
      wx.config({
        beta: true,
        debug: false,
        appId: config.corpid,
        timestamp: config.timestamp,
        nonceStr: config.noncestr,
        signature: config.signature,
        jsApiList: ['getContext', 'invoke']
      })
      
      wx.ready(() => {
        console.log('[企微SDK] wx.config ready')
        isWxReady = true
        
        wx.agentConfig({
          corpid: agentConfig.corpid,
          agentid: agentConfig.agentid,
          timestamp: agentConfig.timestamp,
          nonceStr: agentConfig.noncestr,
          signature: agentConfig.signature,
          jsApiList: ['getContext'],
          success: () => {
            console.log('[企微SDK] wx.agentConfig success')
            isAgentReady = true
            resolve(true)
          },
          fail: (err) => {
            console.error('[企微SDK] wx.agentConfig fail:', err)
            resolve(false)
          }
        })
      })
      
      wx.error((err) => {
        console.error('[企微SDK] wx.config error:', err)
        resolve(false)
      })
    })
  } catch (error) {
    console.error('[企微SDK] 初始化失败:', error)
    return false
  }
}

export async function silentLogin() {
  if (!isInWechatWork()) {
    console.log('[企微SDK] 非企微环境，跳过静默登录')
    return null
  }
  
  const existingToken = getToken()
  if (existingToken) {
    console.log('[企微SDK] 已有token，跳过静默登录')
    return existingToken
  }
  
  const initialized = await initWxConfig()
  if (!initialized) {
    console.log('[企微SDK] 初始化失败，无法静默登录')
    return null
  }
  
  return new Promise((resolve) => {
    window.wx.invoke('getContext', {}, async (res) => {
      console.log('[企微SDK] getContext result:', res)
      
      if (res.err_msg !== 'getContext:ok') {
        console.error('[企微SDK] getContext 失败:', res.err_msg)
        resolve(null)
        return
      }
      
      const ticket = res.ticket
      if (!ticket) {
        console.error('[企微SDK] 未获取到 ticket')
        resolve(null)
        return
      }
      
      try {
        const response = await fetch('/api/app/oauth/wechat-work/silent-login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ticket })
        })
        
        const result = await response.json()
        console.log('[企微SDK] silent-login result:', result)
        
        if (result.code === 200 && result.data?.token) {
          setToken(result.data.token)
          console.log('[企微SDK] 静默登录成功')
          resolve(result.data.token)
        } else if (result.data?.bind_status === 0) {
          console.log('[企微SDK] 用户未绑定，需要绑定账号')
          resolve({ needBind: true, data: result.data })
        } else {
          console.error('[企微SDK] 静默登录失败:', result.msg)
          resolve(null)
        }
      } catch (error) {
        console.error('[企微SDK] 静默登录请求失败:', error)
        resolve(null)
      }
    })
  })
}

export async function trySilentLogin() {
  if (!isInWechatWork()) {
    return false
  }
  
  const result = await silentLogin()
  return !!result && !result.needBind
}
